module.exports = __webpack_public_path__ + "img/pause_circle.32fb21e1.svg";